import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { LoginComponent } from './login.component';

import { FormsModule } from '@angular/forms';


@NgModule({
    imports: [SharedModule,FormsModule],
    declarations: [LoginComponent],
    exports: [LoginComponent],
    entryComponents: [LoginComponent]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authentication/login/login.module.ts